import { useState } from "react";
import MainLayout from "./layout/MainLayout";
import ExerciseSelector from "./components/exercise/ExerciseSelector";
import PowerConfig from "./components/power/PowerConfig";
import TimerScreen from "./components/power/TimerScreen";
import ResultScreen from "./components/power/ResultScreen";
import { generateSequence, generateMultiplicationSequence, generateDivisionSequence } from "./utils/generateSequence";
import FlickerScreen from "./components/addition/FlickerScreen";
import AdditionResultScreen from "./components/addition/ResultScreen";
import AdditionSummaryScreen from "./components/addition/SummaryScreen";
import Sidebar from "./components/sidebar/Sidebar";

export default function App() {
const [screen, setScreen] = useState("selector");
const [addValue, setAddValue] = useState(0);
const [result, setResult] = useState(null);
const [startValue, setStartValue] = useState(0);
const [targetCount, setTargetCount] = useState(0);
const [config, setConfig] = useState(null);

const [additionConfig, setAdditionConfig] = useState(null);
const [history, setHistory] = useState([]); 
const [isSidebarOpen, setIsSidebarOpen] = useState(false); 

return (
  <div className="wrapper">

    <div className="mobile">

      {screen === "result" ? (
        <ResultScreen
          result={result}
          onRetry={() => setScreen("selector")}
        />
      ) : screen === "additionResult" ? (
        <AdditionResultScreen
          result={result}
          questionIndex={history.length}
          totalScore={history.filter(h => h.correct === h.user).length}
          onNext={() => {
            const isMul = additionConfig.type === "multiplication";
            const isDiv = additionConfig.type === "division";
            
            const generated = isMul
              ? generateMultiplicationSequence(additionConfig.digitSize, additionConfig.numDigits)
              : isDiv
                ? generateDivisionSequence(additionConfig.dividendSize, additionConfig.divisorSize)
                : generateSequence(additionConfig.digitSize, additionConfig.numDigits);

            setAdditionConfig({
              ...additionConfig,
              sequence: generated.sequence,
              answer: generated.answer,
            });

            setScreen("additionFlicker");
          }}
          onExit={() => setScreen("additionSummary")}
        />
      ) : screen === "additionSummary" ? (
        <AdditionSummaryScreen 
          history={history} 
          onExit={() => {
            setHistory([]);
            setScreen("selector");
          }} 
        />
      ) : (
        <MainLayout onMenuClick={() => setIsSidebarOpen(true)}>
          <Sidebar 
            isOpen={isSidebarOpen} 
            onClose={() => setIsSidebarOpen(false)} 
            onNavigate={(newScreen) => setScreen(newScreen)}
          />
          {screen === "selector" && (
            <ExerciseSelector
              onNext={(data) => {
                setConfig(data);
                setScreen("power");
              }}
              onStartAddition={(data) => {
                const generated = generateSequence(data.digitSize, data.numDigits);

                setAdditionConfig({
                  ...data,
                  sequence: generated.sequence,
                  answer: generated.answer,
                });

                setScreen("additionFlicker");
              }}
              onStartMultiplication={(data) => {
                const generated = generateMultiplicationSequence(data.digitSize, data.numDigits);

                setAdditionConfig({
                  ...data,
                  sequence: generated.sequence,
                  answer: generated.answer,
                });

                setScreen("additionFlicker");
              }}
              onStartDivision={(data) => {
                const generated = generateDivisionSequence(data.dividendSize, data.divisorSize);

                setAdditionConfig({
                  ...data,
                  sequence: generated.sequence,
                  answer: generated.answer,
                });

                setScreen("additionFlicker");
              }}
            />
          )}

          {screen === "power" && (
            <PowerConfig
              config={config}
              onStart={(data) => {
                setAddValue(data.addValue);
                setStartValue(data.startValue);
                setTargetCount(data.targetCount);
                setScreen("timer");
              }}
            />
          )}

          {screen === "timer" && (
            <TimerScreen
              config={config}
              addValue={addValue}
              startValue={startValue}
              targetCount={targetCount}
              onExit={() => setScreen("selector")}
              onFinish={(data) => {
                setResult(data);
                setScreen("result");
              }}
            />
          )}
          {screen === "additionFlicker" && (
            <FlickerScreen
              config={additionConfig}
              onFinish={(data) => {
                setResult(data);
                setHistory([...history, data]);
                setScreen("additionResult");
              }}
            />
          )}
        </MainLayout>
      )}

    </div>

  </div>
);
}